import type { SettingsSearchRow } from "../settings-search-types";

/** Anchor ids for the Workspace page's rows — shared by the page and the
 *  search catalog (see rows/preferences.ts). */
export const WORKSPACE_ANCHORS = {
  avatar: "avatar",
  name: "name",
  deleteWorkspace: "delete-workspace",
} as const;

export const WORKSPACE_SEARCH_ROWS: readonly SettingsSearchRow[] = [
  {
    anchor: WORKSPACE_ANCHORS.avatar,
    label: "Workspace avatar",
    keywords: ["logo", "icon", "image"],
  },
  {
    anchor: WORKSPACE_ANCHORS.name,
    label: "Workspace name",
    keywords: ["rename"],
  },
  {
    anchor: WORKSPACE_ANCHORS.deleteWorkspace,
    label: "Delete the Workspace",
    keywords: ["danger", "remove workspace"],
  },
];
